import React from 'react';
import moment from 'moment';
import { Tabs, Tab, Typography } from '@material-ui/core';

const ClusterTabs = ({ tabValue, handleChangeTab, authenticatedUser, cluster, role }) => {
	// Check if cluster has user-defined applications
	const hasClusterApplications = cluster?.applications && Array.isArray(cluster.applications) && cluster.applications.length > 0;
	
	// Check if Access tab should be disabled for super-admin users
	// Access tab is disabled if:
	// 1. User is a super-admin AND
	// 2. The cluster is not owned by the super-admin user
	const isAccessTabDisabled = () => {
		if (!role || !role.includes('super-admin') || !cluster) {
			return false; // Not a super-admin or no cluster data, so no restriction
		}
		
		// For super-admin users, disable access if they don't own the cluster
		// Check both owner field and user array for ownership
		const isOwner = cluster.owner?.toString() === authenticatedUser.id?.toString() ||
						cluster.owner?._id?.toString() === authenticatedUser.id?.toString() ||
						(cluster.user && cluster.user.includes(authenticatedUser.username));
		
		return !isOwner; // Disable access tab if not the owner
	};

	return (
		<React.Fragment>
			<Tabs
				classes={{ root: 'w-full h-64' }}
				id="cluster_view_cluster-view-tabs"
				value={tabValue}
				onChange={handleChangeTab}
				indicatorColor="secondary"
				textColor="secondary"
				variant="scrollable"
				scrollButtons="auto"
			>
				{/* Applications tab - only shown when cluster has user-defined applications */}
				{hasClusterApplications && (
					<Tab id="cluster_view_tab-applications" className="h-60 normal-case font-bold" label="Applications" />
				)}
				<Tab id="cluster_view_tab-cluster-info" className="h-60 normal-case font-bold" label="Cluster Info" disabled={authenticatedUser.participant} />
				<Tab id="cluster_view_tab-queue" className="h-60 normal-case font-bold" label="Queue" disabled={authenticatedUser.participant} />
				<Tab id="cluster_view_tab-nodes" className="h-60 normal-case font-bold" label="Nodes" />
				<Tab id="cluster_view_tab-access" className="h-60 normal-case font-bold" label="Access" disabled={isAccessTabDisabled()} />
				<Tab id="cluster_view_tab-observability" className="h-60 normal-case font-bold" label="Observability" disabled={authenticatedUser.participant} />
				<Tab id="cluster_view_tab-config" className="h-60 normal-case font-bold" label="Configuration" />
			</Tabs>
			<div className="flex flex-col justify-center items-center pr-32">
				<Typography className="text-15 font-bold" color="textSecondary">
					{moment().format('M/D/YY')}
				</Typography>
				<Typography className="text-15 font-bold" color="textSecondary">
					{moment().format('HH:mm:ss')}
				</Typography>
			</div>
		</React.Fragment>
	);
};

export default ClusterTabs;
